export enum LogScreenMode {
  GLOBAL_LOGS = "global",
  INDIVIDUAL_LOGS = "individual",
}

export enum SortDirection {
  ASCENDING = "ascending",
  DESCENDING = "descending",
}
